<!-- 自転車情報 -->
<template>
  <div class="passcode-area">
    <p>パスコード</p>
    <p>{{ value }}</p>
    <p>解錠の時はこちらをご入力ください</p>
  </div>
</template>

<script>
export default {
  name: "CycleInfoPasscode",
  props: {
    value: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.passcode-area {
  text-align: center;
  padding: 3vh 0;
}
.passcode-area p:nth-child(1) {
  font-size: 20px;
  font-weight: bold;
}

.passcode-area p:nth-child(2) {
  font-size: 30px;
  font-weight: bold;
  padding: 20px 0 15px;
}
.passcode-area p:nth-child(3) {
  font-size: 14px;
}
</style>
